import React from 'react';
import { SimpleTag } from '@atlaskit/tag';
import Tooltip from '@atlaskit/tooltip';
import styled from '@emotion/styled';
import { BILLED_EXTERNALLY } from '@css-xp/ppc-constants';

type BilledExternallyTagProps = {
  text?: string;
  withToolTip?: boolean;
  toolTipContent?: string;
  marginLeft?: string;
};

// simple tag component from atlaskit has a default margin which might not be needed in some cases hence taking it as a prop
const BilledExternallyTagWrapper = styled.span<{ marginLeft?: string }>`
  margin-left: ${(props) => props.marginLeft}px;
  span {
    margin-left: 0;
  }
`;

export const BilledExternallyTag: React.FC<BilledExternallyTagProps> = ({
  text = BILLED_EXTERNALLY,
  withToolTip = false,
  toolTipContent = '',
  marginLeft = '4',
}) => {
  if (withToolTip) {
    return (
      <Tooltip content={toolTipContent} tag="span" position="mouse" testId="billed-externally-tooltip">
        <SimpleTag text={text} testId="billed-externally-text-with-tooltip" />;
      </Tooltip>
    );
  }
  return (
    <BilledExternallyTagWrapper marginLeft={marginLeft}>
      <SimpleTag text={text} testId="billed-externally-text" />
    </BilledExternallyTagWrapper>
  );
};
